import React from 'react';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';

const Footer = () => {
  return (
    <>
      <footer>
        <div className="footer max-w-full mx-auto px-4 sm:px-6 bg-gray-100 py-20 relative">

          {/* ===== Top area: Blocks ===== */}
          <div className="grid sm:grid-cols-12 gap-5 py-8 md:py-12 lg:ml-11">

            {/* 1st block: Company Info */}
            <div className="col-span-12 lg:col-span-4">
              <div className="bg-[#e0f0ff] border-l-4 border-[#15467a] p-8 rounded-xl text-center md:text-left xl:w-80 mx-auto shadow-md">
                <h3 className="font-bold text-3xl md:text-4xl mb-4 font-sans text-[#15467a]">Gravient Technologies</h3>
                <div className="text-md font-medium text-gray-700 space-y-1">
                  <h5>Faridabad</h5>
                  <p>Haryana - 121002</p>
                  <p>India</p>
                </div>
              </div>
            </div>

            {/* 2nd block: Links */}
            <div className="col-span-6 md:col-span-6 lg:col-span-1 ml-7 mx-auto">
              <h6 className="text-[#15467a] text-xl font-bold mb-4 font-sans">LINKS</h6>
              <ul className="text-md space-y-2">
                <li>
                  <HashLink to="#home" smooth className="text-[#013289] hover:text-gray-900 transition duration-250 ease-in-out">
                    Home
                  </HashLink>
                </li>
                <li>
                  <HashLink to="#about" smooth className="text-[#013289] hover:text-gray-900 transition duration-250 ease-in-out">
                    About
                  </HashLink>
                </li>
                <li>
                  <HashLink to="#services" smooth className="text-[#013289] hover:text-gray-900 transition duration-250 ease-in-out">
                    Services
                  </HashLink>
                </li>
                <li>
                  <HashLink to="#contact" smooth className="text-[#013289] hover:text-gray-900 transition duration-250 ease-in-out">
                    Contact
                  </HashLink>
                </li>
              </ul>
            </div>

            {/* 3rd block: Services */}
            <div className="col-span-6 md:col-span-6 lg:col-span-4 mx-auto">
              <h6 className="text-[#15467a] text-xl font-bold mb-4 font-sans">OUR SERVICES</h6>
              <ul className="text-md space-y-2">
                <li>
                  <Link to="#" className="text-[#013289] hover:text-gray-900 transition duration-250 ease-in-out">Web Development</Link>
                </li>
                <li>
                  <Link to="#" className="text-[#013289] hover:text-gray-900 transition duration-250 ease-in-out">Dealer Management System</Link>
                </li>
                <li>
                  <Link to="#" className="text-[#013289] hover:text-gray-900 transition duration-250 ease-in-out">Software Testing</Link>
                </li>
                <li>
                  <Link to="#" className="text-[#013289] hover:text-gray-900 transition duration-250 ease-in-out">General IT Consultations</Link>
                </li>
              </ul>
            </div>

            {/* 4th block: Social Media */}
            <div className="col-span-12 text-center mx-auto lg:col-span-3 font-bold uppercase text-[#15467a]">
              <div className="text-xl mb-6 font-sans">Social Media Links.</div>
              <div className="text-md font-medium mb-6">Follow us on social media.</div>
              <div className="mx-auto text-center mt-2 flex justify-center gap-4">
                <a href="https://www.linkedin.com/company/enlighteneering-inc-" target="_blank" rel="noreferrer" className="bg-blue-600 w-10 h-10 flex items-center justify-center rounded-full hover:bg-blue-700 transition">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="w-5 h-5 fill-white">
                    <circle cx="4.983" cy="5.009" r="2.188"></circle>
                    <path d="M9.237 8.855v12.139h3.769v-6.003c0-1.584.298-3.118 2.262-3.118 1.937 0 1.961 1.811 1.961 3.218v5.904H21v-6.657c0-3.27-.704-5.783-4.526-5.783-1.835 0-3.065 1.007-3.568 1.96h-.051v-1.66H9.237zm-6.142 0H6.87v12.139H3.095z"></path>
                  </svg>
                </a>

                <a href="https://www.facebook.com/ENLIGHTENEERING/" target="_blank" rel="noreferrer" className="bg-blue-600 w-10 h-10 flex items-center justify-center rounded-full hover:bg-blue-700 transition">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="w-5 h-5 fill-white">
                    <path d="M13.397 20.997v-8.196h2.765l.411-3.209h-3.176V7.548c0-.926.258-1.56 1.587-1.56h1.684V3.127A22.336 22.336 0 0 0 14.201 3c-2.444 0-4.122 1.492-4.122 4.231v2.355H7.332v3.209h2.753v8.202h3.312z"></path>
                  </svg>
                </a>
              </div>
            </div>
          </div>

          {/* ===== Footer Bottom Copyright ===== */}
          <div className="flex flex-wrap items-center md:justify-between justify-center mx-auto px-4 mt-8">
            <div className="w-full md:w-4/12 px-4 mx-auto text-center py-2">
              <div className="text-sm text-white font-semibold py-1">
                Copyright &copy; {new Date().getFullYear()}{' '}
                <HashLink to="#home" smooth className="hover:text-gray-300 font-sans">
                  Gravient Technologies
                </HashLink>
                . All rights reserved.
              </div>
            </div>
          </div>

        </div>
      </footer>
    </>
  );
};

export default Footer;
